import { createSlice } from '@reduxjs/toolkit';

const DEFAULT_STATE = {
  supportCount: 0,
  contactUsCount: 0,
  initialized: false,
};

const normalizeCount = (value, fallback = 0) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : fallback;
};

const supportCountsSlice = createSlice({
  name: 'supportCounts',
  initialState: DEFAULT_STATE,
  reducers: {
    setSupportCounts: (state, action) => {
      state.supportCount = normalizeCount(action.payload?.supportCount, state.supportCount);
      state.contactUsCount = normalizeCount(action.payload?.contactUsCount, state.contactUsCount);
    },
    initializeSupportCounts: (state, action) => {
      state.supportCount = normalizeCount(action.payload?.supportCount, state.supportCount);
      state.contactUsCount = normalizeCount(action.payload?.contactUsCount, state.contactUsCount);
      state.initialized = true;
    },
  },
});

export const { setSupportCounts, initializeSupportCounts } = supportCountsSlice.actions;

export const selectSupportCounts = (state) => state.supportCounts ?? DEFAULT_STATE;

export default supportCountsSlice.reducer;
